<template>
  <div class="main-container minh-100">
    <div class="main-content-wrap">
      <div class="wrapper flex-1">
        <div class="title">Settings</div>
        <div class="site-settings-wrapper">
          <div class="label-wrapper">
            <div>Site Settings</div>
            <div class="button" @click="onButtonClick">Save Settings</div>
          </div>
          <div class="list-wrapper">
            <div class="list-item">
              <input type="checkbox" v-model="interviewCheckbox" />
              <div>Follow up with emails to interview candidates every</div>
              <input
                type="text"
                class="list-input"
                style="width: 78px"
                v-model="interviewDays"
              />
              <div>days.</div>
            </div>
            <div class="list-item">
              <input type="checkbox" v-model="offerCheckbox" /> Follow up with
              <div>emails to offer candidates ever</div>
              <input
                type="text"
                class="list-input"
                style="width: 78px"
                v-model="offerDays"
              />
              <div>days.</div>
            </div>
            <div class="list-item">
              <input type="checkbox" v-model="invoiceCheckbox" />
              <div>Auto generate invoice as</div>
              <model-select
                :options="invoiceOptions"
                v-model="invoiceType"
                style="width: 80px"
              ></model-select>
              <div>every 1st day of the next month.</div>
              <div class="button" @click="createLastMonthInvoice">Run</div>
            </div>
            <div class="list-item">
              <input type="checkbox" v-model="quizCheckbox" />
              <div>Select</div>
              <model-select
                :options="quizOptions"
                v-model="quizType"
                style="width: 280px"
              ></model-select>
              <div>as default application status.</div>
            </div>
            <div class="list-item">
              <input type="checkbox" v-model="consultantSlackChannelCheckbox" />
              <div>Consultant slack channel</div>
              <input
                type="text"
                class="list-input"
                style="width: 120px"
                v-model="consultantSlackChannel"
              />
            </div>
            <div class="list-item">
              <input type="checkbox" v-model="projectSlackChannelCheckbox" />
              <div>Project slack channel</div>
              <input
                type="text"
                class="list-input"
                style="width: 120px"
                v-model="projectSlackChannel"
              />
            </div>
            <div class="list-item">
              <div>Email Name:</div>
              <input
                type="text"
                class="list-input"
                style="width: 132px"
                v-model="emailName"
              />
            </div>
            <div class="list-item">
              <div>Email Account:</div>
              <input
                type="text"
                class="list-input"
                style="width: 132px"
                v-model="emailAccount"
                autocomplete="off"
              />
            </div>
            <div class="list-item">
              <div>Email Password:</div>
              <input
                type="password"
                class="list-input"
                style="width: 132px"
                v-model="emailPassword"
                autocomplete="off"
              />
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="table-title-wrapper">
            <div class="label-wrapper">
              <div>Metros</div>
              <div class="button" @click="onAddMetroClick">Add Metro</div>
            </div>
          </div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="metroGridOptions"
            :columnDefs="metroColumnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="metroRowData"
          ></ag-grid-vue>
        </div>
        <div class="table-wrapper">
          <div class="table-title-wrapper">
            <div class="label-wrapper">
              <div>Tech Levels</div>
              <div class="button" @click="onAddTechLevelClick">
                Add Tech Level
              </div>
            </div>
          </div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="techLevelGridOptions"
            :columnDefs="techLevelColumnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="techLevelRowData"
          ></ag-grid-vue>
        </div>
        <div class="table-wrapper">
          <div class="table-title-wrapper">
            <div class="label-wrapper">
              <div>Work Types</div>
              <div class="button" @click="onAddWorkTypeClick">
                Add Work Type
              </div>
            </div>
          </div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="workTypeGridOptions"
            :columnDefs="workTypeColumnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="workTypeRowData"
          ></ag-grid-vue>
        </div>
        <div class="table-wrapper">
          <div class="table-title-wrapper">
            <div class="label-wrapper">
              <div>Application Statuses</div>
              <div class="button" @click="onAddApplicationStatusClick">
                Add Application Status
              </div>
            </div>
          </div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="applicationStatusGridOptions"
            :columnDefs="applicationStatusColumnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="applicationStatusRowData"
          ></ag-grid-vue>
        </div>
        <ToolsTable @buttonClick="onAddToolsClick" />
        <SkillsTable @buttonClick="onAddSkillsClick" />
        <CertificationsTable @buttonClick="onAddCertificationsClick" />
        <ProjectPhasesTable @buttonClick="onAddProjectPhasesClick" />
        <RoleStatusesTable @buttonClick="onAddRoleStatusesClick" />
        <TechStatusesTable @buttonClick="onAddTechStatusesClick" />
        <SoftwareTable @buttonClick="onAddSoftwareClick" />
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelMetro
            v-if="editOpen == 1"
            :submitLoading="metroSubmitLoading"
            @buttonClick="onMetroButtonClick"
          ></PanelMetro>
          <PanelTechLevel
            v-if="editOpen == 2"
            :submitLoading="techLevelSubmitLoading"
            :propsData="techLevelPropsData"
            @buttonClick="onTechLevelButtonClick"
          ></PanelTechLevel>
          <PanelWorkType
            v-if="editOpen == 3"
            :submitLoading="workTypeSubmitLoading"
            @buttonClick="onWorkTypeButtonClick"
          ></PanelWorkType>
          <PanelApplicationStatus
            v-if="editOpen == 4"
            :submitLoading="applicationStatusSubmitLoading"
            :propsData="applicationStatusPropsData"
            @buttonClick="onApplicationStatusButtonClick"
          ></PanelApplicationStatus>
          <ToolsPanel
            v-if="editOpen == 5"
            @closePanel="closeEditPannel"
            :propsData="toolPropsData"
          />
          <SkillsPanel
            v-if="editOpen == 6"
            @closePanel="closeEditPannel"
            :propsData="skillPropsData"
          />
          <CertificationsPanel
            v-if="editOpen == 7"
            @closePanel="closeEditPannel"
            :propsData="certificationPropsData"
          />
          <ProjectPhasesPanel
            v-if="editOpen == 8"
            @closePanel="closeEditPannel"
          />
          <RoleStatusesPanel
            v-if="editOpen == 9"
            @closePanel="closeEditPannel"
            :propsData="roleStatusPropsData"
          />
          <TechStatusesPanel
            v-if="editOpen == 10"
            @closePanel="closeEditPannel"
          />
          <SoftwarePanel
            v-if="editOpen == 11"
            @closePanel="closeEditPannel"
            :propsData="softwarePropsData"
          />
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import { db } from "@/vendor/firebase";
import { httpGet } from "@/http/http";
import * as database from "@/vendor/database";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import { AgGridVue } from "ag-grid-vue";
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import PanelMetro from "@/components/admin/settingAdmin/PanelMetro.vue";
import GridMetro from "@/components/admin/settingAdmin/GridMetro.vue";
import PanelTechLevel from "@/components/admin/settingAdmin/PanelTechLevel.vue";
import GridTechLevel from "@/components/admin/settingAdmin/GridTechLevel.vue";
import GridWorkType from "@/components/admin/settingAdmin/GridWorkType.vue";
import PanelWorkType from "@/components/admin/settingAdmin/PanelWorkType.vue";
import GridApplicationStatus from "@/components/admin/settingAdmin/GridApplicationStatus.vue";
import PanelApplicationStatus from "@/components/admin/settingAdmin/PanelApplicationStatus.vue";

import ToolsTable from "./ToolsTable";
import ToolsPanel from "./ToolsPanel";
import SkillsTable from "./SkillsTable";
import SkillsPanel from "./SkillsPanel";
import CertificationsTable from "./CertificationsTable";
import CertificationsPanel from "./CertificationsPanel";
import ProjectPhasesTable from "./ProjectPhasesTable";
import ProjectPhasesPanel from "./ProjectPhasesPanel";
import RoleStatusesTable from "./RoleStatusesTable.vue";
import RoleStatusesPanel from "./RoleStatusesPanel";
import TechStatusesTable from "./TechStatusesTable.vue";
import TechStatusesPanel from "./TechStatusesPanel.vue";
import SoftwareTable from "./SoftwareTable.vue";
import SoftwarePanel from "./SoftwarePanel.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      settings: null,
      settingsId: null,
      submitLoading: false,
      interviewCheckbox: false,
      interviewDays: null,
      offerCheckbox: false,
      offerDays: null,
      invoiceCheckbox: false,
      invoiceType: null,
      invoiceOptions: [
        {
          text: "draft",
          value: "draft",
        },
        {
          text: "final",
          value: "final",
        },
      ],
      metros: null,
      metroGridOptions: null,
      metroColumnDefs: null,
      metroRowData: [],
      metroSubmitLoading: false,
      techLevels: null,
      techLevelGridOptions: null,
      techLevelColumnDefs: null,
      techLevelRowData: [],
      techLevelSubmitLoading: false,
      techLevelPropsData: null,
      workTypes: null,
      workTypeGridOptions: null,
      workTypeColumnDefs: null,
      workTypeRowData: [],
      workTypeSubmitLoading: null,
      applicationStatuses: null,
      applicationStatusGridOptions: null,
      applicationStatusColumnDefs: null,
      applicationStatusRowData: [],
      applicationStatusSubmitLoading: null,
      applicationStatusPropsData: null,
      editOpen: false,

      quizCheckbox: false,
      quizOptions: [],
      quizType: null,

      toolPropsData: null,
      skillPropsData: null,
      certificationPropsData: null,
      roleStatusPropsData: null,

      consultantSlackChannel: null,
      consultantSlackChannelCheckbox: false,

      projectSlackChannel: null,
      projectSlackChannelCheckbox: false,

      emailName: null,
      emailAccount: null,
      emailPassword: null,

      software: null,
      softwarePropsData: null,
    };
  },
  components: {
    ModelSelect,
    AgGridVue,
    EditPannel,
    OptionMenu,
    PanelMetro,
    GridMetro,
    PanelTechLevel,
    GridTechLevel,
    GridWorkType,
    PanelWorkType,
    GridApplicationStatus,
    PanelApplicationStatus,
    ToolsTable,
    ToolsPanel,
    SkillsTable,
    SkillsPanel,
    CertificationsTable,
    CertificationsPanel,
    ProjectPhasesTable,
    ProjectPhasesPanel,
    RoleStatusesTable,
    RoleStatusesPanel,
    TechStatusesTable,
    TechStatusesPanel,
    SoftwareTable,
    SoftwarePanel,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    settings: function () {
      this.updateData();
    },
    metros: function () {
      this.updateMetro();
    },
    techLevels: function () {
      this.updateTechLevel();
    },
    workTypes: function () {
      this.updateWorkType();
    },
    applicationStatuses: function () {
      this.updateApplicationStatuses();
    },
  },
  beforeMount() {
    this.bindData();
    this.createColumnDefs();
  },
  methods: {
    onColumnResized: function (params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    createColumnDefs: function () {
      this.metroGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.techLevelGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.workTypeGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.applicationStatusGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.metroColumnDefs = [
        {
          headerName: "Name",
          field: "name",
          flex: 1,
        },
        {
          headerName: "Actions",
          field: "actions",
          width: 180,
          cellClass: ["overflow-visible", "grid-action-flex"],
          cellRendererFramework: "GridMetro",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
      this.techLevelColumnDefs = [
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "Rate",
          field: "rate",
          flex: 1,
        },
        {
          headerName: "Actions",
          field: "actions",
          width: 180,
          cellClass: ["overflow-visible", "grid-action-flex"],
          cellRendererFramework: "GridTechLevel",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
      this.workTypeColumnDefs = [
        {
          headerName: "Name",
          field: "name",
          flex: 1,
        },
        {
          headerName: "Actions",
          field: "actions",
          width: 180,
          cellClass: ["overflow-visible", "grid-action-flex"],
          cellRendererFramework: "GridWorkType",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
      this.applicationStatusColumnDefs = [
        {
          headerName: "Name",
          field: "name",
        },
        {
          headerName: "Html",
          field: "html",
        },
        {
          headerName: "Email Title",
          field: "emailTitle",
        },
        {
          headerName: "Email Text",
          field: "emailText",
          flex: 1,
        },
        {
          headerName: "Actions",
          field: "actions",
          width: 180,
          cellClass: ["overflow-visible", "grid-action-flex"],
          cellRendererFramework: "GridApplicationStatus",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    bindData: function () {
      this.$bind("settings", db.collection("settings"));
      this.$bind("metros", db.collection("metros"));
      this.$bind("techLevels", db.collection("tech_levels"));
      this.$bind("workTypes", db.collection("new_work_types"));
      this.$bind("applicationStatuses", db.collection("application_statuses"));
      this.$bind("software", db.collection("software"));
    },
    updateData: function () {
      if (this.settings && this.settings[0]) {
        const data = this.settings[0];
        this.settingsId = data.id ? data.id : null;
        this.interviewCheckbox = data.interview_checkbox
          ? data.interview_checkbox
          : false;
        this.interviewDays = data.interview_days ? data.interview_days : null;
        this.offerCheckbox = data.offer_checkbox ? data.offer_checkbox : false;
        this.offerDays = data.offer_days ? data.offer_days : null;
        this.invoiceCheckbox = data.invoice_checkbox
          ? data.invoice_checkbox
          : false;
        this.invoiceType = data.invoice_type ? data.invoice_type : null;
        this.quizCheckbox = data.quiz_checkbox ? data.quiz_checkbox : false;
        this.quizType = data.quiz_type ? data.quiz_type : null;
        this.consultantSlackChannel = data.consultant_slack_channel
          ? data.consultant_slack_channel
          : null;
        this.consultantSlackChannelCheckbox =
          data.consultant_slack_channel_checkbox ? true : false;
        this.projectSlackChannel = data.project_slack_channel
          ? data.project_slack_channel
          : null;
        this.projectSlackChannelCheckbox = data.project_slack_channel_checkbox
          ? true
          : false;
        this.emailName = data.email_name ? data.email_name : null;
        this.emailAccount = data.email_account ? data.email_account : null;
        this.emailPassword = data.email_password ? data.email_password : null;
      }
    },
    onButtonClick: function () {
      const interviewDays =
        isNaN(this.interviewDays) || !this.interviewDays
          ? null
          : parseInt(this.interviewDays);
      const offerDays =
        isNaN(this.offerDays) || !this.offerDays
          ? null
          : parseInt(this.offerDays);
      const data = {
        interview_checkbox: this.interviewCheckbox,
        interview_days: interviewDays,
        offer_checkbox: this.offerCheckbox,
        offer_days: offerDays,
        invoice_checkbox: this.invoiceCheckbox,
        invoice_type: this.invoiceType,
        quiz_checkbox: this.quizCheckbox,
        quiz_type: this.quizType,
        consultant_slack_channel: this.consultantSlackChannel,
        consultant_slack_channel_checkbox: this.consultantSlackChannelCheckbox,
        project_slack_channel: this.projectSlackChannel,
        project_slack_channel_checkbox: this.projectSlackChannelCheckbox,
        email_name: this.emailName,
        email_account: this.emailAccount,
        email_password: this.emailPassword,
      };
      this.submitLoading = true;
      if (this.settingsId) {
        db.collection("settings")
          .doc(this.settingsId)
          .set(data)
          .then((docRef) => {
            this.$toasted.global.toast_success({
              message: "save success",
            });
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      } else {
        db.collection("settings")
          .add(data)
          .then((docRef) => {
            this.$toasted.global.toast_success({
              message: "save success",
            });
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.submitLoading = false;
          });
      }
    },
    updateMetro: function () {
      this.metroRowData = [];
      for (const i in this.metros) {
        this.metroRowData.push({
          name: this.metros[i].name,
          id: this.metros[i].id,
        });
      }
    },
    updateTechLevel: function () {
      this.techLevelRowData = [];
      for (const i in this.techLevels) {
        this.techLevelRowData.push({
          name: this.techLevels[i].name,
          id: this.techLevels[i].id,
          order: this.techLevels[i].order,
          rate: this.techLevels[i].rate,
        });
      }
      this.techLevelRowData.sort((a, b) => {
        if (a.order === null || a.order === undefined) return 1;
        if (b.order === null || b.order === undefined) return -1;
        return a.order - b.order;
      });
    },
    updateWorkType: function () {
      this.workTypeRowData = [];
      for (const i in this.workTypes) {
        this.workTypeRowData.push({
          name: this.workTypes[i].name,
          id: this.workTypes[i].id,
        });
      }
    },
    updateApplicationStatuses: function () {
      this.applicationStatusRowData = this.applicationStatuses.map((item) => ({
        ...item,
        emailTitle: item.email_title,
        emailText: item.email_text,
        id: item.id,
      }));
      this.quizOptions = this.applicationStatuses.map((item) => ({
        value: item.name,
        text: item.name,
      }));
    },
    onAddMetroClick: function () {
      this.openEditPannel(1, "Add Metro", false);
    },
    onAddTechLevelClick: function () {
      this.techLevelPropsData = {
        type: "add",
      };
      this.openEditPannel(2, "Add Tech Level", false);
    },
    onAddWorkTypeClick: function () {
      this.openEditPannel(3, "Add Work Type", false);
    },
    onAddApplicationStatusClick: function () {
      this.applicationStatusPropsData = {
        type: "add",
      };
      this.openEditPannel(4, "Add Application Status", false);
    },
    onAddToolsClick: function (data) {
      this.toolPropsData = data;
      this.openEditPannel(5, "Add Tool", false);
    },
    onAddSkillsClick: function (data) {
      this.skillPropsData = data;
      this.openEditPannel(6, "Add Skill", false);
    },
    onAddCertificationsClick: function (data) {
      this.certificationPropsData = data;
      this.openEditPannel(7, "Add Certification", false);
    },
    onAddProjectPhasesClick: function (data) {
      this.openEditPannel(8, "Add Project Phase", false);
    },
    onAddRoleStatusesClick: function (data) {
      this.roleStatusPropsData = data;
      this.openEditPannel(9, "Add Role Status", false);
    },
    onAddTechStatusesClick: function (data) {
      this.openEditPannel(10, "Add Tech Status", false);
    },
    onAddSoftwareClick: function (data) {
      this.softwarePropsData = data;
      this.openEditPannel(11, "Add Software", false);
    },
    deleteMetro: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("metros", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    deleteTechLevel: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("tech_levels", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    deleteWorkType: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("new_work_types", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    deleteApplicationStatus: function (data) {
      if (confirm("do you want to delete?")) {
        const id = data.id;
        database.deleteDoc("application_statuses", id).then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({
              message: "delete success",
            });
          } else {
            this.$toasted.global.toast_error({ message: "delete error" });
          }
        });
      }
    },
    createLastMonthInvoice: function () {
      httpGet("create_last_month_invoice").then((response) => {
        if (response.ok) {
          this.$toasted.global.toast_success({
            message: "delete success",
          });
        }
      });
    },
    onMetroButtonClick: function (data) {
      if (data) {
        this.metroSubmitLoading = true;
        database
          .addDoc("metros", { name: data })
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "add success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.addMetroSubmitLoading = false;
          });
      }
    },
    onTechLevelButtonClick: function (name, rate, type, id) {
      if (name) {
        if (type == "add") {
          this.techLevelSubmitLoading = true;
          database
            .addDoc("tech_levels", {
              name: name,
              rate: rate ? rate : null,
              order: this.techLevelRowData.length,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                this.closeEditPannel();
              } else {
                this.$toasted.global.toast_error({ message: "add error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.techLevelSubmitLoading = false;
            });
        } else if (type == "edit") {
          this.techLevelSubmitLoading = true;
          database
            .updateDocById("tech_levels", id, {
              name: name,
              rate: rate ? rate : null,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "edit success",
                });
                this.closeEditPannel();
              } else {
                this.$toasted.global.toast_error({ message: "edit error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.techLevelSubmitLoading = false;
            });
        }
      }
    },
    onWorkTypeButtonClick: function (data) {
      if (data) {
        this.workTypeSubmitLoading = true;
        database
          .addDoc("new_work_types", { name: data })
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: "add success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({ message: "add error" });
            }
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          })
          .finally(() => {
            this.workTypeSubmitLoading = false;
          });
      }
    },
    onApplicationStatusButtonClick: function (
      name,
      html,
      emailTitle,
      emailText,
      type,
      id
    ) {
      if (name && html) {
        if (type === "add") {
          this.applicationStatusSubmitLoading = true;
          database
            .addDoc("application_statuses", {
              name,
              html,
              email_title: emailTitle ? emailTitle : null,
              email_text: emailText ? emailText : null,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                this.closeEditPannel();
              } else {
                this.$toasted.global.toast_error({ message: "add error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.applicationStatusSubmitLoading = false;
            });
        } else if (type === "edit") {
          this.applicationStatusSubmitLoading = true;
          database
            .updateDocById("application_statuses", id, {
              name: name,
              html: html,
              email_title: emailTitle ? emailTitle : null,
              email_text: emailText ? emailText : null,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "edit success",
                });
                this.closeEditPannel();
              } else {
                this.$toasted.global.toast_error({ message: "edit error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.applicationStatusSubmitLoading = false;
            });
        }
      }
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    orderUpTechLevel: function (data) {
      const orderIndex = this.techLevelRowData.indexOf(data);
      if (
        orderIndex > 0 &&
        orderIndex !== 0 &&
        orderIndex < this.techLevelRowData.length
      ) {
        const newOrderIndex = orderIndex - 1;
        const originData = this.techLevelRowData[newOrderIndex];
        database.updateDocById("tech_levels", data.id, {
          order: newOrderIndex,
        });
        database.updateDocById("tech_levels", originData.id, {
          order: orderIndex,
        });
      }
    },
    orderDownTechLevel: function (data) {
      const orderIndex = this.techLevelRowData.indexOf(data);
      if (orderIndex >= 0 && orderIndex < this.techLevelRowData.length - 1) {
        const newOrderIndex = orderIndex + 1;
        const originData = this.techLevelRowData[newOrderIndex];
        database.updateDocById("tech_levels", data.id, {
          order: newOrderIndex,
        });
        database.updateDocById("tech_levels", originData.id, {
          order: orderIndex,
        });
      }
    },
    editTechLevel: function (data) {
      this.techLevelPropsData = {
        type: "edit",
        name: data.name,
        rate: data.rate,
        id: data.id,
      };
      this.openEditPannel(2, "Edit Tech Level", false);
    },
    editApplicationStatus: function (data) {
      this.applicationStatusPropsData = {
        type: "edit",
        name: data.name,
        html: data.html,
        emailTitle: data.emailTitle,
        emailText: data.emailText,
        id: data.id,
      };
      this.openEditPannel(4, "Edit Application Status", false);
    },
  },
};
</script>

<style scoped>
.wrapper {
  background-color: var(--grey-lightest);
  padding: 66px 44px 44px;
}
.wrapper > :not(:first-child) {
  margin-top: 24px;
}
.title {
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  font-family: inter-regular;
}
.site-settings-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  padding: 24px;
}
.label-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  font-family: inter-regular;
}
.button {
  padding: 4px 8px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
  font-weight: 500;
  font-family: inter-regular;
}
.list-wrapper {
  margin-top: 12px;
}
.list-wrapper > :not(:first-child) {
  margin-top: 16px;
}
.list-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #585757;
}
.list-item > :not(:first-child) {
  margin-left: 8px;
}
.list-item .dropdown {
  max-height: 28px;
  color: #969696;
  font-size: 13px;
}
.list-input {
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 4px 8px;
  min-width: 50px;
  font-size: 13px;
  line-height: 20px;
  color: #969696;
  outline: none;
}
.table-wrapper {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
}
.table-title-wrapper {
  padding: 24px 24px 6px;
}
</style>
